import jwt from 'jsonwebtoken'

const PayLoad = (token) => {
  const data = jwt.decode(token)
  return {
    ...data,
    ability: [
      {
        action: 'manage',
        subject: 'all'
      }
    ]
  }
}

export default PayLoad
